import { EffectsMapObject } from "dva";

import { ReducersMapObject } from "redux";

import { freeze } from "immer";

import { app } from "@reco-w/core-ui";
import { Namespaces, headerModel as oldheaderModel } from "@reco-w/policy-layout-models";
import { ARTICLE_ROOT_CODE } from "@reco-w/article-models";
import { parkCateService } from "../service";

export namespace headerModel {
    export const namespace = Namespaces.header;
    let articleCatalogs = [];
    export const state: any = freeze({}, !0);

    export type StateType = typeof state;
    export const reducers: ReducersMapObject = {
        ...oldheaderModel.reducers,
        initState() {
            return state;
        },
    };
    export const effects: EffectsMapObject = {
        ...oldheaderModel.effects,
        /**
          * 获取服务联盟类型
          * @param { message }
          * @param { call, put, select }
         */
        *getArticleCatalog({ message }, { call, put }) {
            try {
                if (!articleCatalogs?.length) {
                    articleCatalogs = yield call(parkCateService.postList, { authorized: false, rootCode: ARTICLE_ROOT_CODE });
                }

                yield put({ type: "input", data: { articleCatalogs } });
            } catch (e) {
                yield call(message!.error, "getArticleCatalog" + e.errmsg);
            }
        },
    };
}

export function registerPageHeaderModel(model?: any) {
    app.replaceModel(model || headerModel);
}
